const loginReducer  = (state = { orders: [] } , action)=>{
    switch(action.type){
        case "login": return {...state, orders: action.payload};
        default: return state;
    }
}


export default loginReducer